import { CustomSignaturesConstants } from '../store/customSignature.constants'

export const customSignatureSchemas = [
  {
    inputKey: CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_SIGNATORY_NAME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CUSTOM_SIGNATURE_SIGNATORY_NAME: {
        type: 'string',
        pattern: '^([\x00-\x7F\xA0-\xFF]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CUSTOM_SIGNATURE_SIGNATORY_NAME'],
    errorMessage: {
      properties: {
        SET_CUSTOM_SIGNATURE_SIGNATORY_NAME: 'Must be alphanumeric with max length of 250',
      },
    },
  },
  {
    inputKey: CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_SIGNING_REASON,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CUSTOM_SIGNATURE_SIGNING_REASON: {
        type: 'string',
        pattern: '^([\x00-\x7F\xA0-\xFF]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CUSTOM_SIGNATURE_SIGNING_REASON'],
    errorMessage: {
      properties: {
        SET_CUSTOM_SIGNATURE_SIGNING_REASON: 'Must be alphanumeric with max length of 250',
      },
    },
  },
  {
    inputKey: CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_SIGNATORY_RELATION,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CUSTOM_SIGNATURE_SIGNATORY_RELATION: {
        type: 'string',
        pattern: '^([\x00-\x7F\xA0-\xFF]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CUSTOM_SIGNATURE_SIGNATORY_RELATION'],
    errorMessage: {
      properties: {
        SET_CUSTOM_SIGNATURE_SIGNATORY_RELATION: 'Must be alphanumeric with max length of 250',
      },
    },
  },
  {
    inputKey: CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_SIGNATORY_PHONE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CUSTOM_SIGNATURE_SIGNATORY_PHONE: {
        type: 'string',
        pattern: '^([2-9][0-9][0-9]-[2-9][0-9][0-9]-[0-9][0-9][0-9][0-9])$',
      },
    },
    additionalProperties: false,
    required: ['SET_CUSTOM_SIGNATURE_SIGNATORY_PHONE'],
    errorMessage: {
      properties: {
        SET_CUSTOM_SIGNATURE_SIGNATORY_PHONE: 'Must be in the format: NNN-NNN-NNNN',
      },
    },
  },
]
